import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useGlobalCore } from '../../core/modules/global';

export default function GlobalSnackbar() {
  const { snackbarOpen, snackbarMessage, snackbarOptions = { variant: 'info' }, hideSnackbar } = useGlobalCore();

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    hideSnackbar();
  };

  return (
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={snackbarOptions.variant} sx={{ width: '100%' }} variant="filled">
        {snackbarMessage}
      </Alert>
    </Snackbar>
  );
}